import React from 'react'
import { TimerText } from '../TimerText'
import './style.less'

export type WaitCallErrorProps = {
  expireAt?: any
  onTimeout?: () => any
  onBack?: () => any
  className?: string
  btnClassName?: string
  hideBackBtn?: boolean
  /**
   * `"По данному номеру телефона уже открыта сессия авторизации."`
   */
  text1?: string
  /**
   * `"Пожалуйста, закройте предыдущую сессию или попробуйте войти в аккаунт через"`
   */
  text2?: string
}

export const WaitCallError = (props: WaitCallErrorProps) => {
  const text1 = props.text1 ?? 'По данному номеру телефона уже открыта сессия авторизации.'
  const text2 = props.text2 ?? 'Пожалуйста, закройте предыдущую сессию или попробуйте войти в аккаунт через'
  const timer = props.expireAt ? <TimerText expireAt={props.expireAt} onTimeout={props.onTimeout} /> : '15 мин.'
  const backJsx = (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault()
        props.onBack?.()
      }}
    >
      {'Назад'}
    </a>
  )
  const className = props.className ?? 'description waitcall-error'
  const btnClassName = props.btnClassName ?? 'back-btn'
  return (
    <div className={className}>
      <span>{text1}</span>
      <br />
      <span>
        {text2}
        {' '}
        {timer}
      </span>
      {props.hideBackBtn ? null : <div className={btnClassName}>{backJsx}</div>}
    </div>
  )
}
